export default __webpack_public_path__ + "static/media/emoji.a94a434b.jpeg";